/** Device-local favorite listing IDs — same key on web + mobile. */

export const FAVORITES_STORAGE_KEY = 'redevicer_favorites_v1'

export function parseFavoriteIds(raw: string | null | undefined): number[] {
  if (!raw) return []
  try {
    const parsed = JSON.parse(raw)
    if (!Array.isArray(parsed)) return []
    return parsed.filter((x): x is number => typeof x === 'number' && Number.isFinite(x))
  } catch {
    return []
  }
}

export function serializeFavoriteIds(ids: number[]): string {
  return JSON.stringify(ids)
}

export function toggleFavoriteId(ids: number[], id: number): number[] {
  return ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id]
}
